var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0", margin: "0", height: "100%" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "app-container",
          attrs: { "element-loading-text": "加载中..." },
        },
        [
          _c(
            "el-card",
            {
              staticClass: "sticky-container",
              attrs: { shadow: "never", "body-style": { padding: 0 } },
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "el-row",
                    { staticClass: "filter-container", attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 6 } },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            attrs: {
                              placeholder: "用户昵称、手机号或分享码",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.keyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "keyword", $$v)
                              },
                              expression: "queryParams.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 3 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: { placeholder: "用户身份", clearable: "" },
                              model: {
                                value: _vm.queryParams.userGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "userGrade", $$v)
                                },
                                expression: "queryParams.userGrade",
                              },
                            },
                            _vm._l(_vm.memberLevel, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.levelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 3 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: { placeholder: "消费等级", clearable: "" },
                              model: {
                                value: _vm.queryParams.consumerLevel,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "consumerLevel",
                                    $$v
                                  )
                                },
                                expression: "queryParams.consumerLevel",
                              },
                            },
                            _vm._l(_vm.consumeLevel, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.levelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 3 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: { placeholder: "状态", clearable: "" },
                              model: {
                                value: _vm.queryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "status", $$v)
                                },
                                expression: "queryParams.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "禁用", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "启用", value: 1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.handleFilter },
                            },
                            [_vm._v("查找")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    { name: "sticky-header", rawName: "v-sticky-header" },
                  ],
                  attrs: {
                    stripe: "",
                    fit: "",
                    "highlight-current-row": "",
                    data: _vm.list,
                    "header-cell-class-name": "table-header-cell",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      width: "60",
                      align: "center",
                      type: "index",
                      "class-name": "table-header-cell",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.$index +
                                    1 +
                                    (_vm.queryParams.page - 1) *
                                      _vm.queryParams.limit
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "用户昵称",
                      prop: "nickName",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("filterMemberName")(row.nickName))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "手机号",
                      prop: "mobile",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "分享码",
                      prop: "shareCode",
                      "min-width": "80",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "身份等级",
                      prop: "gradeName",
                      align: "center",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "消费等级",
                      prop: "consumerName",
                      align: "center",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "邀请人",
                      prop: "inviterName",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "注册时间",
                      prop: "createTime",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "80", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-dropdown",
                              { attrs: { trigger: "click" } },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _vm._v(" 操作"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleDetail(row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("用户详情")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: { divided: "" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleFundRecord(row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("更改推荐人")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: { divided: "" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleFundRecord(row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("更改推荐人")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                attrs: {
                  total: _vm.total,
                  page: _vm.queryParams.page,
                  limit: _vm.queryParams.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.queryParams, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.queryParams, "limit", $event)
                  },
                  pagination: _vm.fetchData,
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "用户详情",
            top: "5vh",
            width: "600px",
            visible: _vm.detailDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
          },
        },
        [
          _c("member-detail", { attrs: { "member-id": _vm.memberId } }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.detailClose } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }